/**
 * HOC that normalizes a block's `data` (legacy -> unified schema) before it
 * reaches the wrapped view. Used to wrap the stock search and listing block
 * views so migrated blocks query the new catalog indexes / portal types without
 * touching the (faithfully migrated) content.
 */
import React from 'react';
import normalizeBlockData from '../searchMap';

export default function withNormalizedData(Wrapped) {
  const Normalized = (props) => (
    <Wrapped {...props} data={normalizeBlockData(props.data)} />
  );
  Normalized.displayName = `withNormalizedData(${
    Wrapped?.displayName || Wrapped?.name || 'View'
  })`;
  Normalized.__ppNormalized = true;
  return Normalized;
}
